import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'

const axiosRequest = (extraParams: any = {}) =>
  AxiosInitializer({
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  })

const projectAPI = {
  fetch: (projectId: string, params = {}) =>
    apiWrapper({
      endPoint: () =>
        axiosRequest({ transformResConfig: true }).get(
          `/projects/${projectId}`,
          {
            params,
          },
        ),
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default projectAPI
